<emr-modal headerTitle="View Logs" i18n-headerTitle="@@view_logs" [bsModalRef]=bsShowViewLogModalRef>
    <div modal-body class="col-md-12">
      <app-show-viewlog [getHistoryTripRequest]="getHistoryTripRequest"  (CancelClick)="onPopupCancel()"></app-show-viewlog>
    </div>
  </emr-modal>
